@if (props.multiple) {
  <select class="form-control form-select"
    multiple
    [class.form-select]="props.customSelect"
    [formControl]="selectFormControl"
    [class.is-invalid]="showError"
    [formlyAttributes]="field"
    (ngModelChange)="onSelectionChange($event)">
    @for (item of props.options | formlySelectOptions:field | async; track item) {
      @if (item.group) {
        <optgroup label="{{item.label}}">
          @for (child of item.group; track child) {
            <option [ngValue]="child.value" [disabled]="child.disabled">
              {{ child.label }}
            </option>
          }
        </optgroup>
      }
      @if (!item.group) {
        <option [ngValue]="item.value" [disabled]="item.disabled">{{ item.label }}</option>
      }
    }
  </select>
} @else {
  <select class="form-control form-select"
    [formControl]="selectFormControl"
    [class.form-select]="props.customSelect"
    [class.is-invalid]="showError"
    [formlyAttributes]="field"
    (ngModelChange)="onSelectionChange($event)">
    @if (props.placeholder) {
      <option [ngValue]="null">{{ props.placeholder }}</option>
    }
    @for (item of props.options | formlySelectOptions:field | async; track item) {
      @if (item.group) {
        <optgroup label="{{item.label}}">
          @for (child of item.group; track child) {
            <option [ngValue]="child.value" [disabled]="child.disabled">
              {{ child.label }}
            </option>
          }
        </optgroup>
      }
      @if (!item.group) {
        <option [ngValue]="item.value" [disabled]="item.disabled">{{ item.label }}</option>
      }
    }
  </select>
}
